module.exports = __webpack_public_path__ + "media/images/print_icon-487692e007831449a763b6d62fe2c412.svg";